import { render } from "./SingleLeadView.vue?vue&type=template&id=9b139dda"
import script from "./SingleLeadView.vue?vue&type=script&lang=js"
export * from "./SingleLeadView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__